<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Select treatment timeslot</h5>
                <a class="close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </a>
            </div>
            <div class="modal-body">
                <div class="p-4 mt-4 mb-4 text-center" *ngIf="!avLoaded">
                    <i class="fa fa-spinner fa-spin"></i>
                </div>
                <ng-container *ngFor="let g of guests">
                    <div class="timeslot-container" *ngIf="g.active">
                        <p class="">Select time for {{g.name}}</p>
                        <div class="p-2 hover" style="border-bottom: 1px solid #eee;" *ngFor="let slot of timeslots" (click)="selectSlot(slot)">
                            <div class="row">
                                <div class="col-4">{{slot.start_time | date : 'HH:mm'}}</div>
                                <div class="col-4">{{slot.total_cost / 100 | currency : 'GBP'}}</div>
                                <div class="col-4">{{slot.appointments.length}} left</div>
                            </div>
                        </div>
                    </div>

                </ng-container>
            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade show modal-slide-show"></div>
